import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import './About.css'; // Reuse About page styles

const Partners = () => {
  const partnerTypes = [
    {
      title: 'Technology Partners',
      description: 'Leading cloud platforms, development tools, and infrastructure providers that power our solutions.',
      partners: ['AWS', 'Microsoft Azure', 'Google Cloud Platform', 'Docker', 'Kubernetes']
    },
    {
      title: 'Integration Partners',
      description: 'Enterprise software vendors and SaaS platforms we integrate with seamlessly.',
      partners: ['Salesforce', 'SAP', 'Oracle', 'ServiceNow', 'Workday']
    }
  ];

  const benefits = [
    'Access to enterprise-grade technology platforms',
    'Joint solution development and co-innovation',
    'Technical training and certification programs',
    'Dedicated partner support and resources',
    'Market development and co-marketing opportunities',
    'Early access to new features and capabilities'
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Strategic Partnerships</h1>
          <p>
            We collaborate with industry-leading technology providers to deliver 
            comprehensive, best-in-class solutions to our clients.
          </p>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Partnership Approach</h2>
            <p>
              Our partnerships with leading technology vendors enable us to provide enterprise-grade 
              solutions backed by robust platforms and tools. These relationships ensure our clients 
              benefit from the latest innovations, security updates, and technical support from 
              industry leaders.
            </p>
            <p>
              We maintain certifications and deep technical expertise across multiple platforms, 
              allowing us to architect solutions that leverage the best capabilities of each 
              technology stack while ensuring seamless integration and optimal performance.
            </p>
          </div>
        </div>
      </section>

      <section className="about-expertise">
        <div className="container">
          <div className="section-header">
            <h2>Partner Ecosystem</h2>
            <p>Technology alliances that strengthen our service delivery</p>
          </div>
          
          <div className="values-grid">
            {partnerTypes.map((type, index) => (
              <div key={index} className="value-card">
                <h3>{type.title}</h3>
                <p style={{ marginBottom: '16px' }}>{type.description}</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {type.partners.map((partner, idx) => (
                    <span 
                      key={idx}
                      style={{
                        padding: '4px 12px',
                        background: '#ffffff',
                        border: '1px solid #dcdcde',
                        fontSize: '12px',
                        color: '#50575e',
                        fontWeight: '600'
                      }}
                    >
                      {partner}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-values">
        <div className="container">
          <div className="section-header">
            <h2>Partnership Benefits</h2>
            <p>Value delivered through our technology alliances</p>
          </div>
          
          <div className="expertise-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="expertise-item">
                {benefit}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Explore Partnership Opportunities</h2>
            <p>Interested in partnering with SoftLaabs? Contact us to discuss collaboration possibilities.</p>
            <Link to="/contact">
              <Button 
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: '#2271b1',
                  color: '#ffffff',
                  fontWeight: '600',
                  padding: '14px 32px',
                  fontSize: '15px',
                  textTransform: 'none',
                  borderRadius: '3px',
                  boxShadow: '0 1px 0 #135e96',
                  transition: 'all 0.2s',
                  '&:hover': {
                    backgroundColor: '#135e96',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }
                }}
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partners;
